<template>
    <el-drawer
            :title="titleDrawer"
            :before-close="handleClose"
            :visible="dialogShow"
            direction="rtl"
            custom-class="copy-shell"
            :show-close="true"
            :close-on-press-escape="true"
            ref="drawer"
            append-to-body
    >
        <div
          class="drawer-content h-full"
          :style="{height: contentHeight}"
        >
            <!--scrollbar没有效果 todo-->
<!--            <el-scrollbar style="height: 100%;"> &lt;!&ndash; 滚动条 &ndash;&gt;
                <slot></slot>
            </el-scrollbar>-->
          <VuePerfectScrollbar
            class="scroll-area--customizer pt-4 pb-6 shop-car-drawer" :settings="settings" :key="$vs.rtl"
          >
            <slot></slot>
          </VuePerfectScrollbar>
          <slot name="footer"></slot>
        </div>
    </el-drawer>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import { mapGetters } from 'vuex'
  export default {
    name: 'copyShell',
    components: {
      VuePerfectScrollbar,
    },
    props: {
      dialogShow: {
        type: Boolean,
        default: false,
      },
      titleDrawer: {
        type: String,
      },
      isShopCar:{
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        settings: {
          maxScrollbarLength : 60,
          wheelSpeed         : .60,
        },
      }
    },
    computed: {
      ...mapGetters(['realMobile']),
      contentHeight(){
        if(!this.isShopCar){
          return `calc(100vh - 64px - 60px)`;
        }else {
          return `calc(100vh - 64px - 100px)`;
        }
      }
    },
    methods: {
      handleClose() {
        this.$emit('close');
      }
    }
  };
</script>
<style lang="scss">
    .drawer-content {
      border-top: 1px solid #E6E6E6;
    }
    .scroll-area--customizer {
      &.shop-car-drawer {
        height: calc(100% - 107px);
      }
    }
</style>
